import { Button } from "@foodpilot/foods";
import { MenuItem, type SxProps, useTheme } from "@mui/material";
import type { MouseEventHandler, ReactNode } from "react";

type CreateNewMenuItemProps = {
    appearance?: "legacy" | "product-v2";
    children: ReactNode;
    disabled?: boolean;
    onClick?: MouseEventHandler<HTMLElement>;
};

export const CreateNewMenuItem = ({ appearance = "legacy", children, disabled, onClick }: CreateNewMenuItemProps) => {
    const theme = useTheme();
    const sharedSx: SxProps = {
        padding: 0,
        gap: theme.spacing(1.5),
        width: "max-content",
        maxWidth: "100%",
        justifyContent: "flex-start",
        opacity: 1,
        borderRadius: 0,
        "> svg:first-of-type": {
            maxWidth: theme.spacing(2.5),
        },
        "> .MuiTypography-root": {
            margin: 0,
        },
        ".MuiTouchRipple-root": {
            display: "none",
        },
        "&.Mui-disabled > *:not(.MuiStack-root:last-child)": {
            color: theme.custom.grey[1400],
            fill: theme.custom.grey[1400],
        },
        "&:hover": {
            background: "transparent",
            color: theme.custom.grey[2000],
        },
    };

    if (appearance === "product-v2") {
        return (
            <Button
                variant="text"
                disabled={disabled}
                onClick={onClick as MouseEventHandler<HTMLButtonElement>}
                sx={sharedSx}
            >
                {children}
            </Button>
        );
    }

    return (
        <MenuItem disabled={disabled} onClick={onClick as MouseEventHandler<HTMLLIElement>} sx={sharedSx}>
            {children}
        </MenuItem>
    );
};
